import { createContext, useContext, type ReactNode } from "react";
import { useLoadScript } from "@react-google-maps/api";

type GoogleMapsLoadContextValue = {
    isLoaded: boolean;
    loadError?: Error;
};

const GoogleMapsLoadContext = createContext<GoogleMapsLoadContextValue>({
    isLoaded: false,
});

/**
 * Single Maps script load for Amplify auth + signed-in app.
 * Starts while auth screens are visible; signed-in shell waits on `isLoaded`
 * unless `loadError` (then the app opens and map UIs degrade).
 */
export function GoogleMapsLoadProvider({ children }: { children: ReactNode }) {
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY || "",
    });

    return (
        <GoogleMapsLoadContext.Provider value={{ isLoaded, loadError }}>
            {children}
        </GoogleMapsLoadContext.Provider>
    );
}

export function useGoogleMapsLoad() {
    return useContext(GoogleMapsLoadContext);
}
